import { useState } from "react";
import { createContext } from "react";

const FormContextApi = createContext()

export const FormProvieder = ({ children }) => {

    const options = [
        { value: '1', label: 'Installation' },
        { value: '2', label: 'Survey' },
        { value: '4', label: 'Reverse Logistics' },
        { value: '5', label: 'Field Support' },
        { value: '13', label: 'Feasibility' },
        { value: '17', label: 'Commissioning' },
    ]


    const [homeFormInit, sethomeFormInit] = useState({ pincode: "", })

    const [userInit, setuserInit] = useState({ user_name: "", email: "", mobile: "", termConditions: "" })

    const [serviceInit, setserviceInit] = useState({
        pincode: "", city: "", address: "", describe: "FE will be carrying - Laptop, CAT6 Patchcord, Console Cable with convertor and tool kit \nService includes - Onsite Smart-Hands support for 1 device \nRemote connection sharing to your team \nOn-ground troubleshooting \nTesting and sign off \nExcluded - Supply of any cables or other accessories", date: "", document: "",
    })

    const [loginMobile, setloginMobile] = useState({ logmobile: "" })

    const [ticketdata, setTicketData] = useState("")

    const [access, setaccess] = useState({ pageacces: true, paymentacces: true, gstModal: false })

    const [walletValue, setwalletValue] = useState(0)

    return (
        <FormContextApi.Provider value={{ homeFormInit, sethomeFormInit, userInit, setuserInit, serviceInit, setserviceInit, loginMobile, setloginMobile, ticketdata, walletValue, setwalletValue, setTicketData, access, setaccess, options }}>
            {children}
        </FormContextApi.Provider>
    )
}

export default FormContextApi